import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }

import { BaseFieldProps } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import useFileApi from 'SharedDir/common/composables/useFileApi';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import { FileSampleFieldParams } from 'SharedDir/declarations/fields';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'FileSampleField' },
  __name: 'FileSample',
  props: {
    label: { default: '' },
    showHistory: { type: Boolean },
    history: {},
    params: {}
  },
  setup(__props: any) {



const props = __props;
const { downloadFile } = useFileApi();
const loading = ref(false);
const download = () => {
  makeRequest(() => downloadFile(props.params.fileId), {
    startLoading: () => {
      loading.value = true;
    },
    finishLoading: () => {
      loading.value = false;
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "s-link",
      onClick: download
    }, [
      _createVNode(_component_q_icon, {
        size: "1.5em",
        name: "attachment",
        class: _normalizeClass({ shaking: loading.value })
      }, null, 8, ["class"]),
      _createTextVNode(" " + _toDisplayString(_ctx.params.title), 1)
    ])
  ]))
}
}

})